import React from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import { capitalizeWord, finderTipoExamenByName } from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  hoursAvailableState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import { examenState, tipoExamenState } from "./state/atoms";
import ModalidadIcon from "../../../shared/icons/ModalidadIcon";

const AutocompleteTipoExamen = ({ size = "small", styles, myEvent }) => {
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const tipoExamenes = useRecoilValue(tipoExamenState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);
  const resetExamen = useResetRecoilState(examenState)
  const lugar = window.location.pathname.indexOf("buscar") >= 0;
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-tipoexamen"
        text="Modalidad"
        style={{ ...styles.label }}
      />
      <Autocomplete
        sx={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-tipoexamen"
        options={
          tipoExamenes ? tipoExamenes.map((option) => `${option.ptD_NOMBRE}`) : []
        }
        getOptionLabel={(option) => capitalizeWord(option) || null}
        value={filterSearchSelected.tipoExamenSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          resetExamen();
          resetHoursAvailable();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              tipoExamenSelected: {
                ...filterSearchSelected.tipoExamenSelected,
                value: "",
                code: null,
              },
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findTipoExamen = finderTipoExamenByName(tipoExamenes, value);

            myEvent(findTipoExamen);
            setFilterSearchSelected({
              ...filterSearchSelected,
              tipoExamenSelected: {
                ...filterSearchSelected.tipoExamenSelected,
                value: value,
                code: findTipoExamen?.ptD_RUT,
              },
              examenSelected: {
                ...filterSearchSelected.examenSelected,
                value: "",
                code: null,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              input: {
                "&::placeholder": {
                  ...styles.autocomplete,
                  opacity: 1,
                  fontWeight: 400,
                },
              },
            }}
            placeholder="Modalidad"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                (lugar > 0 ) ?                 
                <>
                <SvgIcon sx={{fontSize: "15px"}}>
                  <ModalidadIcon />
                </SvgIcon>
                  {params.InputProps.startAdornment}
                </>: null

              ),                
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteTipoExamen;
